import React from "react";
import Row from "react-bootstrap/Row";
import moment from "moment";
import FileSelector from "../UI Component/FileSelector/FileSelector";
// import {patientFiles} from "../../Util/API Calls/APIList";
// import Check from "../../assets/check-pink.svg";
// import Cancel from "../../assets/cross-half.svg";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
// import GetAppIcon from "@material-ui/icons/GetApp";
// import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import Checked from "../../assets/check-pink.svg";

export default function TemplateUpload(props) {
  const {
    label,
    imageSelectHandler,
    file,
    actions,
    loadingFile,
    selectedFile,
    percentage,
    cancelUpload,
    fileValidationLabel,
    error,
    uploadedFile,
  } = props;
  // function base64ToArrayBuffer(base64) {
  //   var binaryString = atob(base64.split(",")[1]);
  //   var binaryLen = binaryString.length;
  //   var bytes = new Uint8Array(binaryLen);
  //   for (var i = 0; i < binaryLen; i++) {
  //     var ascii = binaryString.charCodeAt(i);
  //     bytes[i] = ascii;
  //   }
  //   return bytes;
  // }

  // function saveByteArray(reportName, byte, fileType) {
  //   var blob = new Blob([byte], {type: fileType});
  //   var link = document.createElement("a");
  //   link.href = window.URL.createObjectURL(blob);
  //   var fileName = reportName;
  //   link.download = fileName;
  //   link.click();
  // }

  const getDateTime = (date) => {
    let dateTime = date?.split(".");
    return date != "" ? moment(dateTime[0]).format("DD MMM, YYYY") : null;
  };

  return (
    <>
      {/* style={{marginLeft: "12px"}} */}

      <div className="container container_row mt-2 p-0">
        <div
          className={`mb-sm-2 ${
            label != "Clinic/Hospital Logo"
              ? "upload_label mt-3"
              : "upload_logo_label mt-3"
          }`}
        >
          {label}
        </div>
        {(!uploadedFile && !selectedFile) ||
        (!selectedFile &&
          uploadedFile &&
          Object?.keys(uploadedFile)?.length === 0 &&
          uploadedFile?.constructor === Object) ? (
          <div className="upload_container">
            <div className="document_container">
              <FileSelector
                className="prescription_selector mb-2"
                maxFileSize={5}
                accept={".jpg, .jpeg, .png"}
                onSelect={(image) => imageSelectHandler(image, label)}
              />
            </div>
            {error ? <div className="form_label error">{error}</div> : null}
            <div className="form_label">{fileValidationLabel}</div>
          </div>
        ) : (
          <div className={`${"upload_history_container mt-2 mb-2"}`}>
            {selectedFile ? (
              <Row className="upload-history border">
                <div
                  className="prescription-history-container"
                  style={{ border: "none" }}
                >
                  <div
                    className="mr-2"
                    style={{ width: "30px", height: "30px" }}
                  >
                    <CircularProgressbarWithChildren
                      value={percentage}
                      styles={buildStyles({
                        pathColor: "#F969A4",
                        trailColor: "#edf0ef", //pp === 100 ? "none" : "#edf0ef"
                        color: "#F969A4",
                      })}
                    >
                      {percentage !== 100 ? (
                        <i
                          class="fa fa-close m-1"
                          style={{ fontSize: "18px", color: "#f969a4" }}
                        ></i>
                      ) : (
                        <img
                          src={Checked}
                          alt=""
                          width={32}
                          height={32}
                          className=""
                        />
                      )}
                    </CircularProgressbarWithChildren>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="prescription-file-name">
                      <div className="medical-record-heading">
                        {/* {selectedFile.fileName || (
                        <span>Medical Record {file.length}</span>
                      )} */}
                        {selectedFile.fileName}
                      </div>
                      <div className="medical-record-date">
                        {moment(new Date()).format("HH:mm A | DD MMM, YYYY")}
                      </div>
                    </div>
                    <div className="medical-record-type">
                      {selectedFile.type && selectedFile.type.toUpperCase()}{" "}
                      <div
                        className={`bulletUpload mr-1 ${
                          percentage >= 0 ? "ml-1 mt-2" : "ml-1"
                        }`}
                      />
                      {selectedFile.size}MB
                    </div>
                  </div>
                  <div className="medical-record-container">
                    <div className="m-auto">
                      <i
                        className="trash-icon m-1"
                        onClick={() => cancelUpload()}
                      >
                        <DeleteIcon fontSize="small" />
                      </i>
                    </div>
                  </div>
                </div>
              </Row>
            ) : (
              <Row
                className={`${
                  label == "Clinic/Hospital Logo" ? "upload-history" : "m-2"
                }`}
              >
                <div
                  className="upload-history-container"
                  // style={{border: "none"}}
                >
                  <div
                    className="mr-2"
                    style={{ width: "30px", height: "30px" }}
                  >
                    <CircularProgressbarWithChildren
                      value={percentage}
                      styles={buildStyles({
                        pathColor: "#F969A4",
                        trailColor: "#edf0ef", //pp === 100 ? "none" : "#edf0ef"
                        color: "#F969A4",
                      })}
                    >
                      <img
                        src={Checked}
                        alt=""
                        width={32}
                        height={32}
                        className=""
                      />
                    </CircularProgressbarWithChildren>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="prescription-file-name">
                      <div className="medical-record-heading">
                        {uploadedFile?.name}
                        {/* {selectedFile.fileName || (
                        <span>Medical Record {file.length}</span>
                      )} */}
                      </div>
                      <div className="medical-record-date">
                        {uploadedFile?.uploaded_at &&
                          getDateTime(uploadedFile?.uploaded_at)}
                        {/* {moment(new Date()).format("HH:mm A | DD MMM, YYYY")} */}
                      </div>
                    </div>
                    <div className="medical-record-type">
                      {uploadedFile?.file_type &&
                        uploadedFile?.file_type.toUpperCase()}{" "}
                      <div
                        className={`bulletUpload mr-1 ${
                          percentage >= 0 ? "ml-1 mt-2" : "ml-1"
                        }`}
                      />
                      {uploadedFile?.file_size_in_mb
                        ? `${uploadedFile?.file_size_in_mb} MB`
                        : ""}
                    </div>
                  </div>
                  <div className="medical-record-container">
                    <div className="m-auto">
                      <i
                        className="trash-icon m-1"
                        onClick={() => cancelUpload()}
                      >
                        <DeleteIcon fontSize="small" />
                      </i>
                    </div>
                  </div>
                </div>
              </Row>
            )}
          </div>
        )}
      </div>
    </>
  );
}
